import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { LoaderComponent } from '@app-components/common/loader/loader.component';
import { MatError } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { InfiniteScrollService } from '@app-services/infinite-scroll.service';
import { takeUntil } from 'rxjs/operators';
import { MobileObserverService } from '@app-services/adaptive/mobile-observer.service';

@Component({
  selector: 'app-infinity-scroll',
  templateUrl: './infinity-scroll.component.html',
  imports: [LoaderComponent, MatError, MatIcon, MatIconButton, TranslateModule],
  styleUrls: ['./infinity-scroll.component.scss'],
})
export class InfinityScrollComponent
  implements AfterViewInit, OnDestroy, OnInit
{
  @ViewChild('sentinel') sentinel!: ElementRef;
  private destroy$ = new Subject<void>();
  @Input() isErrorScroll: boolean;
  @Input() isLoadingScroll: boolean;
  @Input() canNavigateForward: boolean;
  @Input() dataLength: number;
  private useMobileViewSubscription: Subscription;
  public useMobileView = false;
  @Output() public loadData = new EventEmitter();
  @Output() public refreshData = new EventEmitter();

  constructor(
    private scrollService: InfiniteScrollService,
    private el: ElementRef,
    private mobileObserverService: MobileObserverService
  ) {}

  ngOnInit(): void {
    this.useMobileViewSubscription = this.mobileObserverService
      .mobileObserver()
      .subscribe(isMobile => (this.useMobileView = isMobile));
    this.onScroll();
  }

  public init(): void {
    this.canNavigateForward &&
      this.scrollService.observe(
        this.useMobileView ? null : this.el.nativeElement.parentElement,
        this.sentinel.nativeElement
      );
  }

  onScroll(): void {
    this.scrollService.loading$
      .pipe(takeUntil(this.destroy$))
      .subscribe(loading => {
        if (loading && this.canNavigateForward) {
          this.loadData.emit();
        }
      });
  }

  refresh(): void {
    this.refreshData.emit();
  }

  ngAfterViewInit(): void {
    this.init();
  }

  public onDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.scrollService.unobserve(this.sentinel.nativeElement);
  }

  public scrollTop(): void {
    this.el.nativeElement.parentElement.scrollTop = 0;
  }

  public reconnect(): void {
    this.onDestroy();
    this.init();
    this.onScroll();
  }

  ngOnDestroy(): void {
    this.onDestroy();
    this.useMobileViewSubscription?.unsubscribe();
  }
}
